import { ICampus } from '../../../interfaces/scheduler_interfaces';

import * as _4 from 'lodash4';
export class Campus implements ICampus {
  static build(campus: ICampus) {
    return new Campus(campus);
  }
  id: number;
  is_global: boolean;
  is_online: boolean;
  name: string;
  rank: number;

  constructor(campus: ICampus) {
    _4.merge(
      this,
      {
        id: -1,
        name: 'TBD',
        is_online: true
      },
      campus
    );
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/sections/builders/campus_builder.ts